(() => {
  if (!window.chrome) {
    return;
  }

  const random = Math.random() * 10000;
  let activePlayer;
  let originalCurrentSources;
  let currentSources;
  let localSeekingPausedTimer;
  let remoteSeekingPausedTimer;
  let remotePausingPausedTimer;
  let localSeekingPaused = false;
  let remoteSeekingPaused = false;
  let remotePausingPaused = false;
  let freshlyCasted = false;

  const pauseLocalSeeking = () => {
    localSeekingPaused = true;
    if (localSeekingPausedTimer === undefined) {
      localSeekingPausedTimer = window.setTimeout(() => {
        localSeekingPaused = false;
        localSeekingPausedTimer = undefined;
      }, 3000);
    }
  };

  const pauseRemoteSeeking = () => {
    remoteSeekingPaused = true;
    if (remoteSeekingPausedTimer === undefined) {
      remoteSeekingPausedTimer = window.setTimeout(() => {
        remoteSeekingPaused = false;
        remoteSeekingPausedTimer = undefined;
      }, 300);
    }
  };

  const pauseRemotePausing = () => {
    remotePausingPaused = true;
    if (remotePausingPausedTimer === undefined) {
      remotePausingPausedTimer = window.setTimeout(() => {
        remotePausingPaused = false;
        remotePausingPausedTimer = undefined;
      }, 1000);
    }
  };

  const beginCasting = () => {
    let currentSrc = activePlayer.media.currentSrc;

    if (currentSources.length) {
      currentSrc = currentSources.shift();
    }

    currentSrc = `${currentSrc}${currentSrc.indexOf('?') === -1 ? '?' : ''}&random=${random}`;

    pauseLocalSeeking();

    freshlyCasted = true;

    if (window.cjs.src !== currentSrc) {
      const wrapper = activePlayer.elements.container.closest('.swinger-video-player');
      const itemNumber = wrapper.getAttribute('data-itemnumber');

      console.log(`CJS Casting file: ${currentSrc}`);

      if (!itemNumber) {
        window.cjs.cast(currentSrc);
        return;
      }

      window.swinger.api.getItemDetails(itemNumber)
        .then((itemData) => {
          const item = itemData[0];
          const language = window.swinger.config.language;

          if (!item) {
            return;
          }

          const metadata = {
            // eslint-disable-next-line no-nested-ternary
            title: item.name[language] ? item.name[language] : (item.name.en ? item.name.en : item.name),
            description: (() => {
              const div = document.createElement('div');
              // eslint-disable-next-line no-nested-ternary
              div.innerHTML = item.description[language] ? item.description[language] : (item.description.en ? item.description.en : item.description);
              return div.textContent.replace(/([!?.])([\S])/g, '$1 $2');
            })(),
            // eslint-disable-next-line no-nested-ternary
            poster: item.image ? (window.swinger.user.isLoggedIn() ? item.image.default : item.image.censored) : undefined,
          };

          window.cjs.cast(currentSrc, metadata);
        })
        .catch(console.info);
    } else {
      window.cjs.play();
    }
  };

  const updateLocalTime = () => {
    if (
      window.cjs.time === 0
      || !activePlayer
      || (Math.abs(activePlayer.currentTime - window.cjs.time) < 1)
    ) {
      return;
    }

    if (localSeekingPaused) {
      return;
    }

    pauseRemoteSeeking();

    activePlayer.currentTime = window.cjs.time;
  };

  const setupSyncLocal = () => {
    window.cjs.on('playing', () => {
      if (activePlayer && freshlyCasted) {
        freshlyCasted = false;
        pauseLocalSeeking();
        window.cjs.seek(activePlayer.currentTime);
      }

      if (!activePlayer || activePlayer.playing) {
        return;
      }

      pauseRemoteSeeking();

      activePlayer.play();
      window.setTimeout(updateLocalTime, 100);
    });

    window.cjs.on('buffering', () => {
      if (!activePlayer || !activePlayer.playing) {
        return;
      }

      pauseRemotePausing();
      activePlayer.pause();
    });

    window.cjs.on('pause', () => {
      if (!activePlayer || !activePlayer.playing) {
        return;
      }

      activePlayer.pause();
    });

    window.cjs.on('timeupdate', () => {
      if (localSeekingPaused) {
        return;
      }

      pauseRemoteSeeking();
      updateLocalTime();
    });

    window.setInterval(() => {
      if (!window.cjs.connected) {
        return;
      }

      // console.log(`CJS player state: ${window.cjs._player.playerState}`);

      const mediaSession = window.cast.framework.CastContext.getInstance().getCurrentSession().getMediaSession();

      if (!mediaSession) {
        beginCasting();
        return;
      }

      if (window.cjs._player.playerState === 'PAUSED') {
        activePlayer.pause();
      }
    }, 1000);

    window.cjs.on('statechange', () => {
      console.log(`CJS statechange: ${window.cjs.state}`);

      if (activePlayer) {
        const wrapper = activePlayer.elements.container.closest('.swinger-video-player');
        if (wrapper) {
          wrapper.classList[window.cjs.state === 'buffering' ? 'add' : 'remove']('swinger-video-player--cast-is-buffering');
        }
      }
    });

    window.cjs.on('event', (e) => {
      console.log(`CJS event: ${e}`);
      console.log(`CJS state: ${window.cjs.state}`);
      console.log(`CJS current time: ${window.cjs.time}`);
    });

    window.cjs.on('error', console.error);
  };

  const syncRemotePositionAndVolume = () => {
    if (!activePlayer) {
      return;
    }

    if (window.cjs.state !== 'playing') {
      window.setTimeout(syncRemotePositionAndVolume, 25);
      return;
    }

    window.cjs.seek(activePlayer.currentTime);
  };

  const syncRemotePlayStatus = () => {
    if (!activePlayer || !activePlayer.playing) {
      return;
    }

    if (!window.cjs || !window.cjs.cast) {
      return;
    }

    const mediaSession = window.cast.framework.CastContext.getInstance().getCurrentSession().getMediaSession();

    if (
      !mediaSession
      || !window.cjs.src
      || (
        !window.cjs.src.startsWith(activePlayer.media.currentSrc)
        && !originalCurrentSources.find((src) => window.cjs.src.startsWith(src))
      )
    ) {
      beginCasting();
      return;
    }

    window.cjs.play();

    if (!remoteSeekingPaused) {
      pauseLocalSeeking();
      syncRemotePositionAndVolume();
      return;
    }
    pauseRemoteSeeking();
  };

  const initCastJS = new Promise((resolve) => {
    const checkConnectedAndSync = () => {
      if (!window.cjs.connected || !window.cjs.available) {
        window.setTimeout(checkConnectedAndSync, 200);
        return;
      }

      syncRemotePlayStatus();
      setupSyncLocal();
    };

    const checkForCastJSExistence = () => {
      if (typeof Castjs !== 'function') {
        window.setTimeout(checkForCastJSExistence, 200);
        return;
      }

      // eslint-disable-next-line no-undef
      window.cjs = new Castjs();

      checkConnectedAndSync();

      resolve(window.cjs);
    };

    checkForCastJSExistence();
  });

  window.swinger.eventHub.register('click', 'google-cast-launcher', () => {
    initCastJS();
  });

  window.swinger.eventHub.register('swinger-video-player:play swinger-video-player:pause swinger-video-player:waiting swinger-video-player:stalled swinger-video-player:seeking swinger-video-player:seeked swinger-video-player:volumechange swinger-video-player:google-cast-launcher', document, (e) => { // Trigger the click event from the keyboard
    if (!e.detail) {
      return;
    }

    const player = e.detail.plyr;

    switch (e.type) {
      case 'swinger-video-player:pause':
        break;

      default:
        if (activePlayer !== player) {
          currentSources = window.swinger.$('source[src]', player.media)
            .map((elem) => elem.src);
          originalCurrentSources = JSON.parse(JSON.stringify(currentSources));
        }
        break;
    }

    activePlayer = player;

    if (!window.cjs || !window.cjs.available || !window.cjs.connected) {
      return;
    }

    console.log(`CJS Plyr event: ${e.type}`);

    switch (e.type) {
      default:
        break;

      case 'swinger-video-player:play':
        syncRemotePlayStatus();
        break;

      case 'swinger-video-player:pause':
        if (!remotePausingPaused && document.visibilityState === 'visible') {
          window.cjs.pause();
        }
        break;

      case 'swinger-video-player:seeking':
        pauseLocalSeeking();
        break;

      case 'swinger-video-player:seeked':
        console.log(`CJS Plyr current time: ${player.currentTime}`);
        console.log(`CJS remoteSeekingPaused: ${remoteSeekingPaused}`);

        if (!remoteSeekingPaused) {
          pauseLocalSeeking();
          const currentTime = player.currentTime;
          window.cjs.seek(currentTime);
          window.setTimeout(() => {
            window.cjs.seek(currentTime);
          }, 100);
        }
        break;
    }
  });

  window.swinger.eventHub.register('keydown', 'google-cast-launcher', (e) => { // Trigger the click event from the keyboard
    const elem = window.swinger.eventHub.getTarget(e);
    const code = e.which;

    // 13 = Return, 32 = Space
    if ((code === 13) || (code === 32)) {
      elem.click();
    }
  });

  window.swinger.observer.initialize('google-cast-launcher', (elem) => {
    window.swinger.i18n()
      .then((i18n) => {
        elem.setAttribute('role', 'button');
        elem.setAttribute('tabindex', '0');
        elem.setAttribute('aria-label', i18n('ui.chrome-cast.start'));

        window.swinger.resourceLoader.script(`${window.swinger.config.assetsBase}/castjs/cast.js?v=${window.swinger.config.version}`);
      })
      .catch(console.info);
  }, false);
})();
